<template>
    <IQOS required :title="'Facebook Pixel'">
        <BaseInput 
            class="mt-16"
            fullWidth 
            v-model="pixel_id" 
            placeholder="Facebook Pixel ID" :disabled="!editing" maxlength="32"/>

        <template #actions>
            <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
        </template>
    </IQOS>
</template>

<script>    
export default {
    data() {
        return {
            editing: false,

            pixel_id: null
        }
    },
    methods: {
        reset() {
            this.pixel_id = this.cafe.facebook_pixel_id;
        },
        showEditUI() {
            this.editing = true;
        },
        hideEditUI() {
            this.editing = false;
            this.reset();
        },
        onEditFinish() {
            this.$store.commit('setFacebookPixelId', this.pixel_id);
            this.$store.dispatch('saveCafe');

            this.editing = false;
        }
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        }
    },
    mounted() {
        this.reset();
    }
}
</script>

<style>

</style>